module.exports = __webpack_public_path__ + "static/marcio-4b49a3f56906512fb0cf649a75cf1ee2.jpg";